
import LeftSection from '~/components/modal/cart/LeftSection.vue';
import RightSection from '~/components/modal/cart/RightSection.vue';

export default {
    components: {
        LeftSection,
        RightSection,
    },
    props: {
        itemids: Array,
        model: String,
        cardColor: String,
        centered: {
            type: Boolean,
            default: false,
        },
        enableValidation: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            cart: {},
            paymentMethod: null,
            formData: {
                email: "",
                password: "",
                confirmPassword: "",
                cardNumber: "",
                expiryDate: "",
                cvv: ""
            },
            errors: {},
            cardType: null,
        };
    },
    mounted() {
        this.$on('close-modal', this.closeModal);
        // Lock body scroll when modal is mounted (client-side only)
        if (process.client && typeof document !== 'undefined') {
            document.body.style.overflow = 'hidden';
        }
    },
    beforeDestroy() {
        this.$off('close-modal', this.closeModal);
        // Restore body scroll when modal is destroyed (client-side only)
        if (process.client && typeof document !== 'undefined') {
            document.body.style.overflow = '';
        }
    },
    methods: {
        closeModal() {
            this.$emit('close');
            if (this.model) {
                this.$parent[this.model] = false;
            }
        },
        handleReloadContent() {
            this.$emit('reload-content');
        }
    },
};
